import { useEffect, useRef, useState } from "react"
import { useImageUload } from "../customHooks/useImageUpload"
import { EditMode } from "../models/utilTypes"
import { fetchProfileImageUrl } from "../services/HelperService"
import { compressImage } from "../services/ImageCompressionService"
import { ProfileStore } from "../stores/ProfileStore"

interface SubProfileImgProps {
    src: string, index: number, main?: boolean, uid: string, store?: ProfileStore, editMode: EditMode
}

export const SubProfileImage = (props: SubProfileImgProps) => {

    const {picUrlState, imgInputRef, handleSelection, selectImage, removePic, setPicUrlState} = useImageUload(props.src)

    useEffect(()=>{
        async function action(){
            let picUrl = await fetchProfileImageUrl(props.uid, props.index)
            setPicUrlState(picUrl?? null)
        }

        action()
    },[])
    

    function getTypeStyle() {
        if (props.main)
            return 'user-profile-main'
        else
            return 'user-profile-sub'
    }

    async function handleImageSelection(e:any){
        const file = handleSelection(e)
        const compressedLoad = await compressImage(file)
        props.store!.setPicData(compressedLoad, props.index)
    }

    function deletePic(){
        removePic()
        props.store!.deletePic(props.index)
    }

    
    return (
        <div className='user-profile-sub-wrapper' style={{height: props.main? 210 : 100}}  >
                {picUrlState != null ? <i className="material-icons"
                hidden={props.editMode == 'VIEW'}
                onClick={deletePic}
                    style={{
                        fontSize: 25,
                        zIndex: 10,
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        display: props.editMode == 'VIEW'? 'none': 'initial'
                    }}>clear</i>: null}
            <input ref={imgInputRef} type="file" accept="image/*" alt="" hidden onChange={handleImageSelection} />
            {picUrlState != null ? <img className={getTypeStyle()} src={picUrlState!} alt="" /> :
                <i className="material-icons-outlined"
                    onClick={selectImage}
                    hidden={props.editMode == 'VIEW'}
                    style={{
                        fontSize: 25,
                        zIndex: 10,
                        width: 130,
                        height: 30,
                        textAlign: 'center',
                        display: props.editMode == 'VIEW'? 'none': 'initial'
                    }}>add</i>
            }
            {props.editMode == 'VIEW' && picUrlState == null? <div style={{width: 130}} />: null}
            
        </div>
    )

}